import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";
import { I18nService } from "../../../../../@core/services/i18n/i18n.service";
import { PostalAddressType } from '../../../../../generated/generated-types';

export function AddressPostalLinkFallbackFields(i18n: I18nService): FormlyFieldConfig[] {
    return [
        // {
        //     className: 'section-label mt-2 ms-2',
        //     // template: '<h6>Kontakt:</h6><hr/>',
        //     template: '<h6>' + i18n.translate(_('addressContactLink.contact')) + ':</h6><hr/>',
        // },
        {
            fieldGroupClassName: 'flex flex-wrap',
            className: "w-full",
            fieldGroup: [

                {
                    fieldGroupClassName: 'flex flex-wrap',
                    props: {
                        label: _('postal-address.details'),
                        icon: 'fa fa-address-card',
                        translate: true,
                    },
                    className: 'w-full',
                    fieldGroup: [
                        {
                            className: "w-full",
                            fieldGroup: [
                                {
                                    fieldGroupClassName: "flex flex-wrap",

                                    fieldGroup: [
                                        {
                                            fieldGroupClassName: "flex flex-wrap",
                                            props: {
                                                label: _('postal-address._'),
                                                translate: true,
                                                hrBelowTitle: true,
                                            },
                                            wrappers: ["simple-title"],
                                            fieldGroup: [
                                                {
                                                    key: 'postalAddress.titleIdentifier',
                                                    className: "w-full",
                                                    type: 'formly-salutation-drop-down',
                                                    expressions: {
                                                        hide: "model.address?.isPrivatePerson === false"
                                                    },
                                                    props: {
                                                        label: 'crm.title',
                                                        translate: true,
                                                        autoLoad: false,
                                                        attributes: {
                                                            optionValue: 'identifier',
                                                            'data-testid': 'formly-address-postal-link-title'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.recipient',
                                                    className: "w-1/2",
                                                    wrappers: ["simple-title"],
                                                    type: 'input',
                                                    props: {
                                                        label: _('postal-address.recipient'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-recipient'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.addition',
                                                    className: "w-1/2",
                                                    wrappers: ["simple-title"],
                                                    type: 'input',
                                                    props: {
                                                        label: _('postal-address.addition'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-addition'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.addition2',
                                                    className: "w-1/2",
                                                    wrappers: ["simple-title"],
                                                    type: 'input',
                                                    props: {
                                                        label: _('postal-address.addition2'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-addition2'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.addition3',
                                                    className: "w-1/2",
                                                    wrappers: ["simple-title"],
                                                    type: 'input',
                                                    props: {
                                                        label: _('postal-address.addition3'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-addition3'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.street',
                                                    className: "w-1/2",
                                                    wrappers: ["simple-title"],
                                                    type: 'input',
                                                    props: {
                                                        label: _('postal-address.street'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-street'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.streetNumber',
                                                    className: "w-1/2",
                                                    wrappers: ["simple-title"],
                                                    type: 'input',
                                                    props: {
                                                        label: _('postal-address.streetNumber'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-streetNumber'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.countryIso',
                                                    className: "w-1/6",
                                                    wrappers: ["simple-title"],
                                                    type: 'formly-country-input',
                                                    props: {
                                                        label: _('postal-address.country'),
                                                        translate: true,
                                                        onlyEU: false,
                                                        isoMode: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-country'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.state',
                                                    className: "w-full md:w-2/6",
                                                    type: 'input',
                                                    props: {
                                                        label: _('postal-address.state'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': "formly-address-postal-link-state"
                                                        }
                                                    },
                                                    wrappers: ["simple-title"],
                                                },
                                                {
                                                    key: 'postalAddress.postalCode',
                                                    className: "w-1/6",
                                                    wrappers: ["simple-title"],
                                                    type: 'formly-zipcode-auto-complete',
                                                    props: {
                                                        label: _('postal-address.postalCode'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-postalCode'
                                                        }
                                                    },
                                                },

                                                {
                                                    key: 'postalAddress.city',
                                                    className: "w-2/6",
                                                    wrappers: ["simple-title"],
                                                    type: 'input',
                                                    props: {
                                                        label: _('postal-address.city'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-city'
                                                        }
                                                    },
                                                }
                                            ]
                                        },
                                        {
                                            fieldGroupClassName: "flex flex-wrap",
                                            props: {
                                                label: _('postal-address.additional-information'),
                                                translate: true,
                                                hrBelowTitle: true,
                                            },
                                            className: "w-full",
                                            wrappers: ["simple-title"],
                                            fieldGroup: [
                                                {
                                                    key: 'postalAddress.postalAddressType',
                                                    className: 'w-full',
                                                    type: "formly-generic-enum-drop-down",
                                                    props: {
                                                        label: "postal-address.postal-address-type",
                                                        translate: true,
                                                        attributes: {
                                                            "enumName": "PostalAddressType",
                                                            "data-testid": "formly-postal-address-type-select"
                                                        }
                                                    },
                                                    defaultValue: PostalAddressType.REGULAR
                                                },
                                                {
                                                    key: 'postalAddress.postOfficeNumber',
                                                    className: "w-full md:w-1/2",
                                                    expressions: {
                                                        hide: "model.postalAddress?.postalAddressType != 'POSTAL_OFFICE'"
                                                    },
                                                    wrappers: ["simple-title"],
                                                    type: 'input',
                                                    props: {
                                                        label: "postal-address.post-office-number",
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-postOfficeNumber'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.packingStationNumber',
                                                    className: "w-full md:w-1/2",
                                                    expressions: {
                                                        hide: "model.postalAddress?.postalAddressType != 'DHL_PACKING_STATION'"
                                                    },
                                                    wrappers: ["simple-title"],
                                                    type: 'input',
                                                    props: {
                                                        label: "postal-address.packing-station-number",
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-packingStationNumber'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.vatId',
                                                    className: "w-full md:w-1/2",
                                                    type: 'input',
                                                    wrappers: ["simple-title"],
                                                    props: {
                                                        label: _('postal-address.vat-id'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-vatId'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.taxId',
                                                    className: "w-full md:w-1/2",
                                                    type: 'input',
                                                    wrappers: ["simple-title"],
                                                    props: {
                                                        label: _('postal-address.tax-id'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-taxId'
                                                        }
                                                    },
                                                }

                                            ]
                                        },
                                        {
                                            fieldGroupClassName: "flex flex-wrap",
                                            props: {
                                                label: _('postal-address.communication'),
                                                translate: true,
                                                hrBelowTitle: true,
                                            },
                                            wrappers: ["simple-title"],
                                            className: "w-full",
                                            fieldGroup: [
                                                //contact data
                                                {
                                                    key: 'postalAddress.phone',
                                                    className: "w-full md:w-1/2",

                                                    type: 'formly-phone-input',
                                                    props: {
                                                        label: _('postal-address.phone'),
                                                        translate: true,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-phone'
                                                        }
                                                    },
                                                    expressions: {
                                                        'props.countryIso': 'model.postalAddress?.countryIso'
                                                    },
                                                    modelOptions: {
                                                        updateOn: 'blur',
                                                        debounce: {
                                                            default: 500
                                                        }
                                                    }
                                                },
                                                {
                                                    key: 'postalAddress.email',
                                                    className: "w-full md:w-1/2",
                                                    type: 'formly-mail-input',
                                                    props: {
                                                        label: _('postal-address.email'),
                                                        translate: true,
                                                        type: 'email',
                                                        icon: 'fa fa-envelope',
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-email'
                                                        }
                                                    },
                                                    validators: {
                                                        validation: ['mails']
                                                    },
                                                    modelOptions: {
                                                        updateOn: 'change',
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            fieldGroupClassName: "flex flex-wrap",
                                            className: "w-full",
                                            props: {
                                                label: _('postal-address.settings'),
                                                translate: true,
                                                hrBelowTitle: true,
                                            },
                                            wrappers: ["simple-title"],
                                            fieldGroup: [
                                                {
                                                    key: 'isDefault',
                                                    className: "col-md-2",
                                                    type: 'checkbox',
                                                    props: {
                                                        indeterminate: false,
                                                        label: _('postal-address.isDefault'),
                                                        translate: true,
                                                        autoload: false,
                                                        hint: _('postal-address.isDefault-tooltip'),
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-isDefault'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'postalAddress.inactive',
                                                    className: "col-md-2",
                                                    type: 'checkbox',
                                                    props: {
                                                        indeterminate: false,
                                                        label: _('common.inactive'),
                                                        translate: true,
                                                        autoload: false,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-inactive'
                                                        }
                                                    },
                                                },
                                                {
                                                    key: 'notes',
                                                    className: "w-full",
                                                    wrappers: ["simple-title"],
                                                    type: 'textarea',
                                                    props: {
                                                        label: _('common.notes'),
                                                        translate: true,
                                                        rows: 3,
                                                        attributes: {
                                                            'data-testid': 'formly-address-postal-link-notes'
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                },
            ]
        },
    ]
}